import { ProductSubtype } from "src/app/ui/models/domains/pbm/Benefit/product-subtype";
import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";

export class Network {
  private networkInfoKey: string;
  private fiscalNumber: string;
  private corporateName: string;
  private tradingName: string;
  private displayName: string;
  private networkComercialProductList: NetworkComercialProduct[];

  public setNetworkInfoKey(value: string): void {
    this.networkInfoKey = value;
  }

  public getNetworkInfoKey(): string {
    return this.networkInfoKey;
  }

  public setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  public getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  public setCorporateName(value: string): void {
    this.corporateName = value;
  }

  public getCorporateName(): string {
    return this.corporateName;
  }

  public setTradingName(value: string): void {
    this.tradingName = value;
  }

  public getTradingName(): string {
    return this.tradingName;
  }

  public setDisplayName(value: string): void {
    this.displayName = value;
  }

  public getDisplayName(): string {
    return this.displayName;
  }

  public setNetworkComercialProductList(value: NetworkComercialProduct[]): void {
    this.networkComercialProductList = value;
  }

  public getNetworkComercialProductList(): NetworkComercialProduct[] {
    return this.networkComercialProductList;
  }

  public getName(): string {
    if (this.displayName) {
      return this.displayName;
    }
    return this.fiscalNumber.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, "$1.$2.$3/$4-$5");
  }
}

export class NetworkComercialProduct {
  private discount: number;
  private productType: ProductType;
  private productSubType: ProductSubtype;

  setDiscount(value: number): void {
    this.discount = value;
  }

  getDiscount(): number {
    return this.discount;
  }

  setProductType(value: ProductType): void {
    this.productType = value;
  }

  getProductType(): ProductType {
    return this.productType;
  }

  setProductSubtype(value: ProductSubtype): void {
    this.productSubType = value;
  }

  getProductSubType(): ProductSubtype {
    return this.productSubType;
  }
}
